import React, { Component } from "react";
import PropTypes from "prop-types";
import PromociokContent from "./PromociokContent";

class PromociokBase extends Component {
  constructor(props) {
    super(props);
  }

  render() {
    let cardStyle = {
      padding: 20
    };

    return (
      <div>
        <div className="animated fadeIn">
          <div className="col-md-12">
            <PromociokContent {...this.props} globals={this.props.globals}/>
          </div>
        </div>
      </div>
    );
  }
}

PromociokBase.propTypes = {
  route: PropTypes.object,
  globals: PropTypes.object
};

export default PromociokBase;
